import React from 'react';
import './FloatRefreshButton.css'; // CSS below

const FloatRefreshButton = ({ onRefresh }) => {
  return (
    <button className="float-refresh-btn" onClick={onRefresh}>
      <i class="fa fa-refresh"></i>

    </button>
  );
};

export default FloatRefreshButton;
